import { makeQuery } from '../types';

type Output = string;

export const getTheme = makeQuery<Output>(`
query GetTheme {
  getTheme
}
`);
